import { formatDate } from "@pentacode/core";
import type { DateString } from "@pentacode/openapi";

export function isCommitted(date: DateString, commitBefore: DateString | null | undefined) {
    return !!commitBefore && date < commitBefore;
}

/** `from` is the dragged entry's date, or `undefined` for new entries and copies, which leave no committed day behind. */
export function timeEntryDropBlockedReason(
    from: DateString | undefined,
    to: DateString,
    commitBefore: DateString | null | undefined
) {
    if (!commitBefore) {
        return null;
    }
    if (isCommitted(to, commitBefore)) {
        return `Zeiteinträge können nicht auf einen Tag vor dem Festschreibungsdatum ${formatDate(commitBefore)} abgelegt werden.`;
    }
    if (from && isCommitted(from, commitBefore)) {
        return `Dieser Zeiteintrag liegt vor dem Festschreibungsdatum ${formatDate(commitBefore)} und kann nicht mehr verschoben werden.`;
    }
    return null;
}
